import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';

import HeroSlider from "./HeroSlider";
import HealthConcerns from "./HealthConcerns";
import KidsVaccinations from "./KidsVaccinations";
import CheckupSection from "./CheckupSection";
import PopularTests from "./PopularTests";
import authService from '../../../Services/authService';
import { useCart } from "../../../Services/CartContext";
import Process from './Process';
import SEOSchema from '../../../utils/SEOSchema';

const Homepage = () => {
  const { fetchCartCount } = useCart();

  const [recommendedtests, setRecommendedTests] = useState([]);
  const [menCheckups, setMenCheckups] = useState([]);
  const [womenCheckups, setWomenCheckups] = useState([]);
  const [kidsCheckups, setKidsCheckups] = useState([]);
  // useEffect(() => {
  //   const isAuthenticated = authService.getCurrentuser() ? true : false;

  //   if (isAuthenticated) {
  //     fetchCartCount();
  //   }
  // }, []);

  // const menCheckups = [
  //   {
  //     image: "/images/men-under-25.png",
  //     alt: "Young man under 25",
  //     ageRange: "Under 25 years",
  //   },
  //   {
  //     image: "/images/men-25-50.png",
  //     alt: "Man between 25-50 years",
  //     ageRange: "25-50 years",
  //   },
  //   {
  //     image: "/images/men-above-50.png",
  //     alt: "Man above 50 years",
  //     ageRange: "Above 50 years",
  //   },
  // ];

  // const womenCheckups = [
  //   {
  //     image: "/images/women-under-25.png",
  //     alt: "Young woman under 25",
  //     ageRange: "Under 25 years",
  //   },
  //   {
  //     image: "/images/women-25-50.png",
  //     alt: "Woman between 25-50 years",
  //     ageRange: "25-50 years",
  //   },
  //   {
  //     image: "/images/women-above-50.png",
  //     alt: "Woman above 50 years",
  //     ageRange: "Above 50 years",
  //   },
  // ];

  useEffect(() => {
    loadCRecommendedTests();
  }, []);

  const loadCRecommendedTests = () => {
    const url = new URL(authService.getApiUrl() + 'genderwise');
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        //Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
        return res.json();
        //}
      })
      .then((result) => {
        if (result.data && result.data.Men) {
          const formatted = result.data.Men.map((item) => ({
            image: authService.getApiDomainUrl() + item.image,
            alt: `${item.gender} ${item.age}`,
            ageRange: item.age,
            id: item.id,
          }));
          setMenCheckups(formatted);
        }

        if (result.data && result.data.Women) {
          const formattedwomen = result.data.Women.map((item) => ({
            image: authService.getApiDomainUrl() + item.image,
            alt: `${item.gender} ${item.age}`,
            ageRange: item.age,
            id: item.id,
          }));
          setWomenCheckups(formattedwomen);
        }

        if (result.data && result.data.Kids) {
          const formattedkids = result.data.Kids.map((item) => ({
            image: authService.getApiDomainUrl() + item.image,
            alt: `${item.gender} ${item.age}`,
            ageRange: item.age,
            id: item.id,
          }));
          setKidsCheckups(formattedkids);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <>
      <Helmet>
        <title>Pranaam365 - Healthcare Services & Medical Tests</title>
        <meta name="description" content="Book medical tests and health checkups online. Comprehensive healthcare services for men, women, and children." />
      </Helmet>
      
      <SEOSchema 
        type="organization"
        data={{
          name: "Pranaam365",
          description: "Healthcare services and medical tests",
          url: window.location.origin,
          logo: `${window.location.origin}/images/pranaam-365-logo.png`,
          phone: "+91-XXXXXXXXXX"
        }}
      />
      
      <SEOSchema 
        type="webpage"
        data={{
          title: "Pranaam365 - Home",
          description: "Book medical tests and health checkups online",
          url: window.location.href
        }}
      />
    
    <div className="min-h-screen bg-[#F5F5F7]">

      <HeroSlider />
      <Process />
      <HealthConcerns />
      {/* <KidsVaccinations /> */}
      <CheckupSection title="Vaccinations for" gender="Kids" cards={kidsCheckups} />
      <CheckupSection title="Recommended Checkups for" gender="Men" cards={menCheckups} />
      <CheckupSection title="Recommended Checkups for" gender="Women" cards={womenCheckups} />
      <PopularTests />

    </div>
    </>
  );
};

export default Homepage;
